var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodStall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#8f8f8f",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 350.569,
    width: 468,
    height: 161.42
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "22,0.011 22,64.778 22.02,64.778 489.98,64.778 490,64.778 490,0.011  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M490,290.567h-0.02V175.123c-10.832,7.314-23.877,11.589-37.902,11.589c-1.443,0-2.88-0.047-4.31-0.139v103.994H64.233 V186.573c-1.43,0.092-2.867,0.139-4.31,0.139c-14.025,0-27.07-4.275-37.902-11.589v115.444H22H0v30h512v-30H490z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.02,118.81c0,20.899,17.003,37.902,37.902,37.902c13.91,0,26.086-7.537,32.679-18.737 c6.594,11.2,18.77,18.737,32.68,18.737s26.086-7.537,32.68-18.737c6.594,11.2,18.77,18.737,32.679,18.737 s26.086-7.537,32.68-18.737c6.594,11.2,18.77,18.737,32.679,18.737s26.086-7.537,32.68-18.737 c6.594,11.2,18.77,18.737,32.68,18.737c13.91,0,26.086-7.537,32.679-18.737c6.594,11.2,18.77,18.737,32.68,18.737 c13.91,0,26.086-7.537,32.68-18.737c6.594,11.2,18.77,18.737,32.679,18.737c20.899,0,37.902-17.003,37.902-37.902V94.778H22.02 V118.81z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodStall);
export default __webpack_public_path__ + "static/media/food-stall.f3feb096e901c1d6417c1fc1b2dbbf13.svg";
export { ForwardRef as ReactComponent };